import React, { useEffect } from 'react'
import { faSlidersSolid } from '@/lib/fa'
import CheckboxWithLabelField from '@/modules/drivers/forms/contract/inputs/CheckboxWithLabelField'
import StageHeader from '@/modules/drivers/forms/shared/StageHeader'
import { DividerHorizontal } from '@/modules/drivers/shared/DividerHorizontal'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { useRaportForm } from '../../context/RaportFormContext'
import Options from './stages/Options'

/** Pełna wersja: znaczniki granic i miejsca. Prosta: okresy z włożoną kartą. */
const CardInsertionWithdrawal = ({ simple = false }: { simple?: boolean }) => {
  const { data, setData } = useRaportForm()
  const { t } = useLocalize()

  useEffect(() => {
    setData((prev: any) => ({
      ...(simple
        ? { groupByDrivers: false, fillGapsInCsv: true }
        : { basicVersion: false }),
      separateFiles: false,
      issuerSignature: false,
      driverSignature: false,
      ...prev,
    }))
  }, [])

  return (
    <div className="tw-flex-1 tw-space-y-4 tw-overflow-auto tw-p-4 tw-pr-8">
      <div className="tw-flex tw-items-start">
        <StageHeader title={t('printout.data')} textSize="sm" icon={faSlidersSolid} />
        <div className="tw-flex tw-flex-1 tw-flex-col tw-gap-1 sm:tw-min-w-[400px]">
          {simple ? (
            <>
              <CheckboxWithLabelField
                field="groupByDrivers"
                data={data}
                setData={setData}
                label={t('printout.card-insertion-group-by-drivers')}
              />
              <CheckboxWithLabelField
                field="fillGapsInCsv"
                data={data}
                setData={setData}
                label={t('printout.card-insertion-fill-gaps')}
              />
            </>
          ) : (
            <CheckboxWithLabelField
              field="basicVersion"
              data={data}
              setData={setData}
              label={t('printout.card-insertion-basic-version')}
            />
          )}
        </div>
      </div>
      <DividerHorizontal />
      <Options setData={setData} data={data} vehicleActivity={false} separateFilesOnly={false} />
    </div>
  )
}

export default CardInsertionWithdrawal
